import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import "../intl.js";
import { deprecated as t } from "../core/deprecate.js";
import { byId as r } from "../core/domUtils.js";
import s from "../core/Evented.js";
import o from "../core/Handles.js";
import "../core/has.js";
import { clone as i } from "../core/lang.js";
import n from "../core/Logger.js";
import { destroyMaybe as a } from "../core/maybe.js";
import { EsriPromiseMixin as d } from "../core/Promise.js";
import { debounce as l, throwIfNotAbortError as c, eachAlways as p } from "../core/promiseUtils.js";
import { generateUUID as h } from "../core/uuid.js";
import { init as m, whenOnce as u } from "../core/watchUtils.js";
import { property as g } from "../core/accessorSupport/decorators/property.js";
import { cast as y } from "../core/accessorSupport/decorators/cast.js";
import { subclass as v } from "../core/accessorSupport/decorators/subclass.js";
import { runTracked as _ } from "../core/accessorSupport/tracking.js";
import { SimpleTrackingTarget as f } from "../core/accessorSupport/tracking/SimpleTrackingTarget.js";
import { createAdvancedProjector as j } from "../libs/maquette-advanced-projector/projector.js";
import { commitAssetPath as w } from "./support/componentsUtils.js";
import { isWidgetConstructor as k, processWidgets as b, WIDGET_SYMBOL as R } from "./support/jsxWidgetSupport.js";
import { getThemeName as S, classes as C } from "./support/widgetUtils.js";
import { onLocaleChange as T } from "../intl/locale.js";
import { fetchMessageBundle as H } from "../intl/messages.js";
var P = "esri.widgets.Widget",
    E = n.getLogger(P);
var L = 0;
var N = new Map(),
    I = {
  widgetIcon: "esri-icon-checkbox-unchecked"
};

function F(e, t) {
  for (var _r in t) {
    null != e[_r] && ("object" == typeof e[_r] && "object" == typeof t[_r] ? F(e[_r], t[_r]) : e[_r] = t[_r]);
  }

  return e;
}

var U = j({
  postProcessProjectionOptions: function postProcessProjectionOptions(e) {
    var t = e.eventHandlerInterceptor,
        r = /capture$/i;

    e.eventHandlerInterceptor = function (e, s, o, i) {
      var n = t(e, s, o, i),
          a = r.test(e);

      if (!((e = e.replace(r, "")).toLowerCase() in o) || a) {
        var _t = e[2].toLowerCase() + e.slice(3),
            _r2 = function _r2(e) {
          return n.call(o, e);
        };

        o.addEventListener(_t, _r2, a);

        var _s = function _s() {
          return o.removeEventListener(_t, _r2, a);
        },
            _d = i.afterRemoved;

        i.afterRemoved = function (e) {
          null == _d || _d(e), _s();
        };
      }

      return n;
    };
  },
  handleInterceptedEvent: function handleInterceptedEvent(e, t, r, s) {
    var o = s.eventPhase,
        i = s.type,
        n = o === Event.CAPTURING_PHASE;
    var a = "on".concat(i).concat(n ? "capture" : "");
    var d = t.properties;
    (a in d || (a = "on".concat(i[0].toUpperCase()).concat(i.slice(1)).concat(n ? "Capture" : ""), a in d)) && (N.clear(), e.scheduleRender(), d[a].call(d.bind || r, s));
  }
});

var $ = !1,
    x = /*#__PURE__*/function (_d2) {
  _inherits(x, _d2);

  var _super = _createSuper(x);

  function x(e, r) {
    var _this;

    _classCallCheck(this, x);

    _this = _super.call(this, e, r), _this._attached = !1, _this._internalHandles = new o(), _this._projector = U, _this._readyForTrueRender = !1, _this.domNode = null, _this.iconClass = I.widgetIcon, _this.label = _this.declaredClass.split(".").pop(), _this.visible = !0, _this.key = _assertThisInitialized(_this), _this._loadLocale = l( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _e, _iterator, _step, _t2;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this._messageBundleProps && _this._messageBundleProps.length)) {
                _context2.next = 6;
                break;
              }

              _context2.next = 3;
              return p(_this._messageBundleProps.map( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
                  var e, t, r;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          e = _ref2.bundlePath, t = _ref2.propertyName;
                          _context.next = 3;
                          return H(e);

                        case 3:
                          r = _context.sent;
                          _this.uiStrings && Object.keys(_this.uiStrings) && (r = F(i(r), _this.uiStrings)), _this[t] = r;

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 3:
              _e = _context2.sent;
              _iterator = _createForOfIteratorHelper(_e);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _t2 = _step.value;
                  _t2.error && E.error("widget-intl:locale-error", _this.declaredClass, _t2.error);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

            case 6:
              _context2.next = 8;
              return _this.loadLocale();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))), w();
    var s = ["light", "dark"],
        n = S() || "light";
    s.includes(n) || t(E, "The following themes are deprecated: light-blue, dark-blue, light-green, dark-green, light-purple, dark-purple, light-red, and dark-red.", {
      version: "4.19",
      warnOnce: !0,
      see: "https://developers.arcgis.com/javascript/latest/styling/"
    });

    var a = "esri-widget-uid-" + h(),
        d = _this.render.bind(_assertThisInitialized(_this));

    _this._trackingTarget = new f(function () {
      return _this.scheduleRender();
    });

    var c = function c() {
      var e;
      if (!_this._readyForTrueRender || _this.destroyed) return null;
      if (!_this.visible) return {
        vnodeSelector: "div",
        properties: {
          key: a,
          class: "",
          styles: {
            display: "none"
          }
        },
        domNode: void 0,
        children: void 0,
        text: void 0
      };
      var t = d();
      var r = t.properties;
      r || (t.properties = r = {});
      var _r3 = r,
          s = _r3.key,
          o = _r3.styles;
      s || (r.key = a), o || (r.styles = o = {}), o.display || (o.display = "");
      var i = 0;
      return null == (e = t.children) || e.forEach(function (e) {
        if (k(e.vnodeSelector)) return;
        var t = e.properties;
        t || (e.properties = t = {}), t.key || (t.key = "".concat(_this.id, "--").concat(i++));
      }), b(_assertThisInitialized(_this), t);
    };

    _this.render = function () {
      if ($) return c();
      var e = N.get(_assertThisInitialized(_this));
      if (e) return e;
      _this._trackingTarget.clear(), $ = !0;

      try {
        e = _(_this._trackingTarget, c);
      } finally {
        $ = !1;
      }

      return N.set(_assertThisInitialized(_this), e), e;
    }, _this.addResolvingPromise(_this._resourcesFetch = _this.beforeFirstRender().then(function () {
      _this._readyForTrueRender = !0, _this._postInitialize();
    }));
    return _this;
  }

  _createClass(x, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(e, t) {
      var r = _objectSpread({}, e);

      return t && (r.container = t), r;
    }
  }, {
    key: "postInitialize",
    value: function postInitialize() {}
  }, {
    key: "beforeFirstRender",
    value: function beforeFirstRender() {
      return Promise.all([this.loadDependencies(), this._loadLocale()]).then(function () {}).catch(c);
    }
  }, {
    key: "loadDependencies",
    value: function () {
      var _loadDependencies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function loadDependencies() {
        return _loadDependencies.apply(this, arguments);
      }

      return loadDependencies;
    }()
  }, {
    key: "loadLocale",
    value: function () {
      var _loadLocale = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function loadLocale() {
        return _loadLocale.apply(this, arguments);
      }

      return loadLocale;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyed || (this._trackingTarget = a(this._trackingTarget), this.viewModel = a(this.viewModel), this._detach(this.container), this._set("container", null), this._internalHandles.destroy(), this._emitter.clear(), this.render = function () {
        return null;
      }, this._projector = null, N.delete(this));
    }
  }, {
    key: "container",
    set: function set(e) {
      this._get("container") || this._set("container", e);
    }
  }, {
    key: "castContainer",
    value: function castContainer(e) {
      return r(e);
    }
  }, {
    key: "id",
    get: function get() {
      return this._get("id") || this.get("container.id") || Date.now().toString(16) + "-widget-" + L++;
    },
    set: function set(e) {
      e && this._set("id", e);
    }
  }, {
    key: "renderable",
    get: function get() {
      return this._resourcesFetch;
    }
  }, {
    key: "test",
    get: function get() {
      return {
        projector: this._projector,
        handles: this._internalHandles
      };
    }
  }, {
    key: "render",
    value: function render() {
      throw new Error("not implemented");
    }
  }, {
    key: "scheduleRender",
    value: function scheduleRender() {
      this.destroyed || (N.delete(this), this._projector.scheduleRender());
    }
  }, {
    key: "classes",
    value: function classes() {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      return C.apply(this, e);
    }
  }, {
    key: "own",
    value: function own(e) {
      arguments.length > 1 && (e = Array.prototype.slice.call(arguments)), this._internalHandles.add(e);
    }
  }, {
    key: "renderNow",
    value: function renderNow() {
      N.delete(this), this._projector.renderNow();
    }
  }, {
    key: "_postInitialize",
    value: function _postInitialize() {
      var _this2 = this;

      var e;
      if (this.destroyed) return;
      this.scheduleRender(), null != (e = this._delegatedEventNames) && e.length && this._internalHandles.add(m(this, "viewModel", function (e, t) {
        t && _this2._internalHandles.remove("delegated-events"), e && _this2._internalHandles.add(_this2._delegatedEventNames.map(function (t) {
          return e.on(t, function (e) {
            _this2.emit(t, e);
          });
        }), "delegated-events");
      })), this.postInitialize();

      var t = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this2._loadLocale().catch(c);

                case 2:
                  _this2.scheduleRender();

                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function t() {
          return _ref4.apply(this, arguments);
        };
      }();

      this._internalHandles.add([T(t), this.watch("uiStrings", t), u(this, "container", /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _this2.destroyed || _this2._attach(e);

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x2) {
          return _ref5.apply(this, arguments);
        };
      }())]);
    }
  }, {
    key: "_attach",
    value: function _attach(e) {
      e && (this._projector.merge(e, this.render), this._attached = !0);
    }
  }, {
    key: "_detach",
    value: function _detach(e) {
      e && this._attached && (this._projector.detach(this.render), e.parentNode && e.parentNode.removeChild(e), this._attached = !1);
    }
  }]);

  return x;
}(d(s.EventedAccessor));

x[R] = !0, e([g()], x.prototype, "_readyForTrueRender", void 0), e([g({
  value: null
})], x.prototype, "container", null), e([y("container")], x.prototype, "castContainer", null), e([g({
  aliasOf: "container"
})], x.prototype, "domNode", void 0), e([g()], x.prototype, "iconClass", void 0), e([g()], x.prototype, "id", null), e([g()], x.prototype, "label", void 0), e([g()], x.prototype, "renderable", null), e([g()], x.prototype, "uiStrings", void 0), e([g()], x.prototype, "viewModel", void 0), e([g()], x.prototype, "visible", void 0), e([g()], x.prototype, "key", void 0), e([g()], x.prototype, "children", void 0), e([g()], x.prototype, "afterCreate", void 0), e([g()], x.prototype, "afterUpdate", void 0), e([g()], x.prototype, "afterRemoved", void 0), x = e([v(P)], x);
var z = x;
export { z as default };